export function enquiryLocation(city, state) {
  const place = city.trim();
  return place.toLowerCase().endsWith(state.toLowerCase()) ? place : `${place}, ${state}`;
}

// Only successful saved enquiries count as leads. No name, phone, email,
// message or precise city is included. An existing analytics setup is reused.
export function recordEnquirySuccess({ service, state, sourcePage }, target = typeof window === "undefined" ? null : window) {
  if (!target) return;
  const dimensions = {
    service_slug: /^[a-z0-9-]{1,100}$/.test(service) ? service : "",
    state_ut: state,
    source_page: (sourcePage || target.location?.pathname || "/").split(/[?#]/)[0],
    method: "website_enquiry",
  };
  try {
    if (typeof target.CustomEvent === "function") target.dispatchEvent(new target.CustomEvent("mynavodayans:enquiry-success", { detail: dimensions }));
    if (typeof target.gtag === "function") target.gtag("event", "generate_lead", dimensions);
  } catch {
    // Analytics availability must never change a successfully saved enquiry.
  }
}
